import styled from '@emotion/styled';
import { Box, Button } from '@mui/material';
import { theme } from '@src/theme';
import { NavLink } from 'react-router-dom';

export const Wrapper = styled(Box)`
  display: grid;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  padding: 6px 24px;
  align-items: start;
`;

export const Cell = styled(Box)`
  display: flex;
  align-items: center;
  position: relative;
  word-break: break-word;
  color: ${theme.palette.grey[700]};
  font-weight: 500;
  height: 42px;
  min-height: 42px;
  text-align: center;
`;

export const NavItem = styled(NavLink)`
  text-decoration: none;
  color: ${theme.palette.secondary.main};
  font-weight: 600;
  display: inline-block;
  align-items: center;
  padding-right: 12px;
  height: 42px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 90%;
  transform: translate(0, 12px);
`;

export const ActionButton = styled(Button)`
  height: 24px;
  padding: 3px 6px;
  line-height: 18px;
  font-weight: 500;
  font-size: 14px;
  & span {
    margin-left: 3px;
  }
`;
